import H from 'history';
import { createContext, useContext } from 'react';

import { mediaSize } from '~/src/dash/components/layout/common';
import { IStore } from '~/src/dash/reducers/store';
import { IMobileDashboardConfig } from '~/src/dash/views/mobile/MobileBaseView/config';
import { IMobileDashboardOverviewConfig } from '~/src/dash/views/mobile/MobileBaseView/Home/configs/overviewConfig';
import { IMobileDashboardLiveConfig } from '~/src/dash/views/mobile/MobileBaseView/Home/configs/liveConfig';

interface IMobileStore extends IStore {
  location: H.Location;
  isSuperUser: boolean;
  children: any;
  [key: string]: any;
}

export const MobileContext = createContext({} as IMobileStore);
export const useMobileStore = (): IMobileStore => useContext(MobileContext);

export interface IMobileState {
  totalWidth: number | null;
  totalHeight: number | null;
  mediaSize: mediaSize;
}

export interface IMobileConfig {
  Dashboards: {
    Main: IMobileDashboardConfig; // parent
    Overview: IMobileDashboardOverviewConfig; // child - overview
    Live: IMobileDashboardLiveConfig; // child - live
  };
}

export const MobileContextState = createContext({} as IMobileState);
export const useMobileState = (): IMobileState => useContext(MobileContextState);

export const MobileConfig = createContext({} as IMobileConfig);
export const useMobileConfig = (): IMobileConfig => useContext(MobileConfig);
